export default {
  mounted(el, binding) {
    el.eventHandler = (event) => {
      // Check if click was outside of element.
      if (!(el === event.target || el.contains(event.target))) {
        // Call method provided in attribute value.
        binding.value();
      }
    };

    setTimeout(() => {
      document.addEventListener('click', el.eventHandler);
    }, 0);
  },
  // Remove event listener when unmounting.
  beforeUnmount(el) {
    document.removeEventListener('click', el.eventHandler);
  },
};
